export default [
    {
        name:'manage',
        path:'manage',
        meta: { title: '平台管理' },
        component: ()=>import('@/pages/manage/index.vue')
    }
]